import React, { useMemo } from "react";

import { IActiveLearningIssue } from "../../../../../../state";
import Card from "../../../../../../atoms/ActiveLearning/Card";
import TextInput from "../../../../../../atoms/ActiveLearning/TextInput";
import TextArea from "../../../../../../atoms/ActiveLearning/TextArea";
import styles from "../../../ActiveLearningIssue.module.scss";
import { ReactComponent as IconLive } from "../../../../../../assets/images/ActiveLearning/icon_live.svg";
import hintImage05 from "../../../../../../assets/images/ActiveLearning/hint/img_05.webp";

type Issue2MaterialProps = {
  issue?: IActiveLearningIssue;
};

export const Issue2Material = (props: Issue2MaterialProps) => {
  const question1 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 1);
  }, [props.issue?.questions]);

  const question2 = useMemo(() => {
    return props.issue?.questions.find(q => q.order_num === 2);
  }, [props.issue?.questions]);

  return (
    <div className={styles.issue}>
      <div className={styles.header}>
        <span className={styles.no}>
          WORK
          {props.issue?.no && props.issue?.no < 10
            ? `0${props.issue?.no}`
            : props.issue?.no}
        </span>
        <p className={styles.title}>{props.issue?.title}</p>
        <p className={styles.read}>
          様々な視点から考えたことで「問い」を立てるための材料が集まった。
          <br />
          WORK01で考えた内容を参考にして、自分が取り組む「問い」を立てよう。
        </p>
      </div>
      {question1 && <TextInput />}
      <img src={hintImage05} alt="良い「問い」に仕上げるためのヒント" />
      {question2 && (
        <div className={styles.themEntry}>
          <p className={styles.title}>{question2.title}</p>
          <p className={styles.read}>
            これまでのLessonで、自分の興味・関心から「問い」の原型を考え、具体的な「問い」を立てた。
            <br />
            どんな事を考えて「問い」を立てたのか、なぜそのように具体的にしたいと思ったのかを思い出しながら、「問い」を立てるまでに気づいたことや考えたことを入力しよう。
          </p>
          <p className={styles.example}>
            例：自分は普段から、「地元がもっと賑わっていたら楽しいのにな」と思っていたため、地元の活性化に関する「問い」を立てた。中でも地元の人がいなくなってしまうのは大学卒業のタイミングだと思ったので──
          </p>
          <div className={styles.textAreaWrapper}>
            <TextArea />
          </div>
        </div>
      )}
      <Card icon={<IconLive />} label={"TRY"} title={"グループワーク"}>
        ①同じテーマ同士でグループをつくろう。
        <br />
        ②自分が立てた「問い」とその理由を順番に発表し合おう。
        <br />
        ③良い「問い」に仕上げるヒントを参考に話し合い、周りの意見を参考にして「問い」を調整しよう。
      </Card>
    </div>
  );
};
export default Issue2Material;
